import React, { useState, useEffect } from "react";
import "./Berita.css";
import imgHeader from "../../assets/image/img-header.png";
import imgHistory from "../../assets/image/img-lomba.png";
import { Header, Banner, Good } from "../../components/joinComponents";
import { Helmet } from "react-helmet";
import AOS from "aos";
import "aos/dist/aos.css";

const Berita = () => {
  const header = {
    title: "Berita",
    description: "Kampung Mundu",
    img: imgHeader,
  };

  const banners = {
    description: "Membawa Esensi Dalam Setiap Cerita Yang DiSajikan",
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease",
    });
  }, []);

  const dataBerita = [
    {
      title: "Lomba 17 Agustus",
      date: "Senin, 12 Oktober 2023",
      description:
        "simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever sincethe 1500s, when an unknown printer took a galley",
      img: imgHistory,
    },

    {
      title: "Lomba Hadroh",
      date: "Senin, 12 Oktober 2023",
      description:
        "simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever sincethe 1500s, when an unknown printer took a galley",
      img: imgHistory,
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          Kampung digital dan teknologi berbasis website megedepankan informasi
          ter-update
        </title>
        <meta
          name='keyword'
          content='mundu, mundu 1902, moendoe, moendoe 1902, kampung digital, website desa, web keren, lubang buaya, jakarta timur, kampung keren'
        />
        <meta
          name='description'
          content='Berita yang kita sajikan berisi tentang informasi dan kegiatan yang diadakan di lingkungan kami dengan segala keseruan dan keaktifan masyarakat kami.'
        />
        <meta
          name='og:title'
          content=' Kampung digital dan teknologi berbasis website megedepankan informasi
          ter-update.'
        />
        <meta
          name='og:description'
          content='Berita yang kita sajikan berisi tentang informasi dan kegiatan yang diadakan di lingkungan kami dengan segala keseruan dan keaktifan masyarakat kami.'
        />
      </Helmet>

      <Header data={header} />
      <div className='container-berita w-full flex flex-col justify-evenly lg:px-10 sm:px-5'>
        <div className='box-berita flex flex-col lg:mt-16 sm:mt-5'>
          <p className='title-history w-fit lg:ml-16 sm:ml-5 md:ml-16 p-3 lg:text-7xl md:text-5xl'>
            Berita & Acara
          </p>
          {/* <p className='title-history w-fit px-3'>{dataCard[0].title}</p> */}
          <p className='title-berita w-fit p-3 lg:text-7xl md:text-5xl'>
            Kampung Mundu
          </p>
        </div>

        {dataBerita.map((data, index) => (
          <div key={index} className='col-berita-group relative'>
            <div className='box-article-profile mb-5 flex items-center justify-between w-full lg:flex-row md:flex-row sm:flex-col-reverse md:gap-5 sm:mt-5'>
              <article className='flex w-full flex-col mt-10 lg:gap-5 sm:gap-4 sm:mt-5 lg:flex-col'>
                <h1 className='title-article-berita sm:text-lg lg:text-3xl max-w-fit lg:leading-none'>
                  {data.title}
                </h1>
                <p className='date text-sm '>{data.date}</p>
                <div className='rowBeritaDesc items-start  w-full flex justify-between lg:flex-row md:flex-row sm:flex-col-reverse md:gap-5 '>
                  <p className='lg:max-w-screen-md md:max-w-screen-md'>
                    {data.description}
                  </p>
                  <img
                    src={data.img}
                    alt=''
                    srcset=''
                    className='img-profile-title mb-5'
                  />
                </div>
                <button className='btn-berita'>Lihat Lebih Banyak</button>
              </article>
            </div>
            <div className='divider-berita w-full'></div>
          </div>
        ))}
      </div>
      <Banner data={banners} />
      <Good />
    </>
  );
};

export default Berita;
